<div class="content-pv">

    <div class="header">
        <img alt="Logo"  src="assets/media/logos/wegestu.png" class="h-70px"/>
        <h2>PV WEGESTU</h2>
        <div class="btn-actions">
            <button type="button" class="annuler" (click)="navigatePVList()" >Retour</button>
            <button class="confirmer" (click)="scrollToSignature()" 
                *ngIf="evalDetails?.status === '2' && evalDetails?.signature_consultant && !evalDetails?.signature_esn">
                Signer
            </button>
            <button  class="download"
            type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" (click)="telechagementPV()" *ngIf="signature_consultant && signature_esn">
            <svg width="15" height="15" viewBox="0 0 15 15"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.70019 11.2752C7.13239 11.6339 7.56459 11.4187 7.70866 11.2752L12.0306 6.9709C12.3188 6.68394 12.3188 6.25351 12.0306 5.96655C11.7425 5.6796 11.3103 5.6796 11.0222 5.96655L7.92476 9.05133V0.729598C7.92476 0.299163 7.63663 0.012207 7.20443 0.012207C6.77223 0.012207 6.4841 0.299163 6.4841 0.729598V9.05133L3.38667 5.96655C3.09854 5.6796 2.66634 5.6796 2.37821 5.96655C2.09008 6.25351 2.09008 6.68394 2.37821 6.9709L6.70019 11.2752Z"
                fill="#265D91" />
            <path
                d="M13.6863 11.4905C13.2541 11.4905 12.966 11.7774 12.966 12.2079V12.9253H1.44066V12.2079C1.44066 11.7774 1.15253 11.4905 0.720331 11.4905C0.288132 11.4905 0 11.7774 0 12.2079V13.6427C0 14.0731 0.288132 14.36 0.720331 14.36H13.6863C14.1185 14.36 14.4066 14.0731 14.4066 13.6427V12.2079C14.4066 11.7774 14.1185 11.4905 13.6863 11.4905Z"
                fill="#265D91" />
        </svg>
            Télécharger
        </button>
        </div>
    </div>
   
    <ng-container *ngIf="evalDetails">
        <div class="top-section">
            <div class="detail"> 
                Detail PV
            </div>
            <div class="row header-pv">
                <div class="col-md-6"  >
                    <div class="row">
                        <div class="col-6 title">
                            <div>Nom d'evaluation</div>
                            <div>Type d'evaluation</div>
                            <div>Date d'envoi</div>
                            <div>Date de réception</div>
                            <div class="min-w-3">Date remplissage compte rendu</div>
                        </div>
                        <div class="col-6 content" >
                            <div> {{ evalDetails?.evaluation.name ? evalDetails?.evaluation.name : '---'}} </div>
                            <div> {{ evalDetails?.evaluation.type ? evalDetails?.evaluation.type : '---'}} </div>
                            <div> {{ evalDetails?.evaluation.sent_at ? (evalDetails?.evaluation.sent_at | date:'dd/MM/yyyy') : '---' }} </div>
                            <div> {{ evalDetails?.evaluation.sent_at_by_consultant ? (evalDetails?.evaluation.sent_at_by_consultant | date:'dd/MM/yyyy') : '---' }} </div>
                            <div> {{ evalDetails?.date_report_filled ? (evalDetails?.date_report_filled | date:'dd/MM/yyyy') : '---'}} </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-6 title">
                            <div>Nom consultant</div>
                            <div>Date signature</div>
                            <div>Nom de l'entreprise</div>
                            <div>Signer par</div>
                            <div>Date signature PV </div>
                        </div>
                        <div class="col-6 content">
                            <div> {{ evalDetails?.consultant ? evalDetails?.consultant : '---' }} </div>
                            <div>  
                                {{ evalDetails?.date_signature_consultant ? (evalDetails?.date_signature_consultant | date:'dd/MM/yyyy') : '---' }} 
                            </div>
                            <div>  {{ evalDetails?.company_name ? evalDetails?.company_name : '---' }} </div>
                            <div>  {{ evalDetails?.reporter_name ? evalDetails?.reporter_name : '---'}} </div> 
                            <div>  
                                {{ evalDetails?.date_signature_esn ? (evalDetails?.date_signature_esn | date:'dd/MM/yyyy') : '---' }} 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="evaluation" *ngIf="evalDetails?.grouped_questions?.length">
            <div *ngFor="let eval of evalDetails?.grouped_questions">
                <div >
                    <div class="eval-section">
                        <h2 class="subject-title">
                            {{ eval?.family_name }}
                        </h2>
                        <div class="subject-content" *ngFor="let subject of eval.questions; let i = index">
                            <div class="question-content">
                                <h5>
                                    <span class="question-counter">{{ i + 1 }}-</span> 
                                    <span class="question">{{ subject.content }}</span>
                                </h5>
                            <div class="rating mb-5" *ngIf="subject?.answers[0]?.stars > 0" >
                                <div class="stars">
                                    <i class="fa fa-star" [class.gold]="subject?.answers[0].stars >= 1"></i>
                                    <i class="fa fa-star" [class.gold]="subject?.answers[0].stars >= 2"></i>
                                    <i class="fa fa-star" [class.gold]="subject?.answers[0].stars >= 3"></i>
                                    <i class="fa fa-star" [class.gold]="subject?.answers[0].stars >= 4"></i>
                                    <i class="fa fa-star" [class.gold]="subject?.answers[0].stars >= 5"></i>
                                </div>
                            </div>
                            </div>
                                <p class="subject-description">{{ subject?.answers[0]?.comment }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div class="report">
            <div class="detail compte-rendu" >
                <h3 class="name-section">Compte rendu</h3>
            </div>
            <div class="compte"  [innerHTML]="safeDescription"></div>
        </div>
        <div class="signature">
            <div  #signatureSection class="signature-box">
                <h3 class="signature-title" style="margin-bottom: 20px;">Signature par entreprise</h3>
                <ng-container *ngIf="evalDetails?.signature_consultant; else signatureEsnHide">
                    <div class="custom-signature-pad  flex-sm-column" *ngIf="!evalDetails?.signature_esn; else signatureImageEsn">
                        <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)"
                            (drawEnd)="drawComplete()"></signature-pad>
                        <div class="d-flex justify-content-center mt-5">
                            <button type="button" class="annuler me-5" (click)="clearSignature()">Effacer</button>
                            <button class="confirmer" (click)="sendSignature()" [disabled]="!this.signatureFile">
                                Confirmer
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-template #signatureEsnHide>
                    <p style="margin:60px">PV pas encore signer par consultant!</p>
                </ng-template>
                    <ng-template #signatureImageEsn>
                        <div class="d-flex flex-sm-column">
                             <img *ngIf="signatureEsn" [src]="signatureEsn" class="signature-image" alt="signature">
                             <span class="name-sign">{{evalDetails?.reporter_name}}</span>
                            <span class="mt-2">{{evalDetails?.date_signature_esn | date:'dd/MM/yyyy'}}</span>
                        </div>
                    </ng-template>
            </div>
            <div class="signature-box">
                <h3 class="signature-title" style="margin-bottom: 20px;">Signature par consultant</h3>
                <div>
                    <div *ngIf="!evalDetails?.signature_consultant; else signatureImageConsultant">
                        <p style="margin:60px">PV pas encore signer par consultant!</p>
                    </div>
                    <ng-template #signatureImageConsultant>
                        <div class="d-flex flex-sm-column">
                            <img *ngIf="signatureConsultant" [src]="signatureConsultant" class="signature-image" alt="signature">
                            <span class="name-sign">{{evalDetails?.consultant}}</span>
                            <span class="mt-2">{{evalDetails?.date_signature_consultant | date:'dd/MM/yyyy'}}</span>
                        </div>
                    </ng-template>
                </div>
            
            </div>
            
        </div>
    </ng-container>
</div>

<ngx-spinner class="custom-spinner"
    bdColor="rgba(255,255,255,1)"
    size="medium"
    color="#fff"
    type="ball-atom"
    [fullScreen]="true"
    >
    <span class="loader">
        <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>